module.exports = __webpack_public_path__ + "files/picaud.66abe23e775f492b6025bc8d16b7be9d.pdf";